var BaseView = require('./facebook/access');
var FacebookPageView = require('./facebook/page');

module.exports = BaseView.extend({
  scope: 'manage_pages',
  apiCall: 'load/albums/facebook/pages',

  thumbnailClickEvent: function (id) {
    this.openNewView('page', FacebookPageView, { pageId: id });
  },

  closeView: function () {
    var isLastSubView = true;

    _.each(this.views, function (view) {
      isLastSubView &= view.closeView();
    });

    return isLastSubView && BaseView.prototype.closeView.call(this);
  }
});
